<template>
	<div class="flexBetween" style="display: flex;">
		<div class="tabsContainer">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="电表" name="first">电表</el-tab-pane>
				<el-tab-pane label="水表" name="second">水表</el-tab-pane>
			</el-tabs>
			<div class="tabHeader">
				<span v-for="tab in tabList" :key="'tab'+tab.value" :class="{'tabAct':nowTab == tab.value}" @click="nowTab = tab.value">{{tab.name}}</span>
			</div>
			<div v-show="nowTab == 0" class="custom-scrollbar tabBody" style="height: calc(100% - 32px);">
				<div class="chargingDetailLi" v-for="single in allChargeMode.SingleBilling" :key="'single'+single.id">
					<p class="chargingTitle">{{single.name}}</p>
					<p class="chargingPrice">单价:{{single.deductionStandard}}元/度</p>
					<div class="chargingOperate">
						<span @click="deleteChargeMode(single)">删除</span><span @click="editChargeMode(single)">编辑</span>
					</div>
				</div>
				<div class="addNewCharging" style="height: 118px;">
					<img @click="addSingleCharge" :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/add_btn.png')" alt="" />
				</div>
			</div>
			<div v-show="nowTab == 3" class="custom-scrollbar tabBody" style="height: calc(100% - 32px);">
				<div class="chargingDetailLi" v-for="single in allChargeMode.SingleBilling" :key="'single'+single.id">
					<p class="chargingTitle">{{single.name}}</p>
					<p class="chargingPrice">单价:{{single.deductionStandard}}元/m³</p>
					<div class="chargingOperate">
						<span @click="deleteChargeMode(single)">删除</span><span @click="editChargeMode(single)">编辑</span>
					</div>
				</div>
				<div class="addNewCharging" style="height: 118px;">
					<img @click="addSingleCharge" :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/add_btn.png')" alt="" />
				</div>
			</div>

			<div v-show="nowTab == 1" class="custom-scrollbar tabBody" style="height: calc(100% - 32px);">
				<div class="chargingDetailLi" v-for="step in allChargeMode.StepBilling" :key="'step'+step.id">
					<p class="chargingTitle">{{step.name}}</p>
					<div class="chargingDetails">
						<p class="flexBetween">0-{{step.stairNumOne}}度<span>{{step.priceOne}}元/度</span></p>
						<p class="flexBetween">{{step.stairNumOne}}-{{step.stairNumTwo}}度<span>{{step.priceTwo}}元/度</span></p>
						<p class="flexBetween">{{step.stairNumTwo}}度以上<span>{{step.priceThree}}元/度</span></p>
					</div>
					<div class="chargingOperate">
						<span @click="deleteChargeMode(step)">删除</span><span @click="editChargeMode(step)">编辑</span>
					</div>
				</div>
				<div class="addNewCharging" style="height: 171px;">
					<img @click="addStepCharge" :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/add_btn.png')" alt="" />
				</div>
			</div>

			<div v-show="nowTab == 4" class="custom-scrollbar tabBody" style="height: calc(100% - 32px);">
				<div class="chargingDetailLi" v-for="step in allChargeMode.StepBilling" :key="'step'+step.id">
					<p class="chargingTitle">{{step.name}}</p>
					<div class="chargingDetails">
						<p class="flexBetween">0-{{step.stairNumOne}}m³<span>{{step.priceOne}}元/m³</span></p>
						<p class="flexBetween">{{step.stairNumOne}}-{{step.stairNumTwo}}m³<span>{{step.priceTwo}}元/m³</span></p>
						<p class="flexBetween">{{step.stairNumTwo}}m³以上<span>{{step.priceThree}}元/m³</span></p>
					</div>
					<div class="chargingOperate">
						<span @click="deleteChargeMode(step)">删除</span><span @click="editChargeMode(step)">编辑</span>
					</div>
				</div>
				<div class="addNewCharging" style="height: 171px;">
					<img @click="addStepCharge" :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/add_btn.png')" alt="" />
				</div>
			</div>

			<!--尖峰平谷-->
			<div v-show="nowTab == 2" class="custom-scrollbar tabBody" style="height:900px;width: 2500px">
				<div class="chargingDetailLi" v-for="item in allChargeMode.PeakAndValleyBilling" :key="'peakAndVallyey'+item.id">
					<p class="chargingTitle">{{item.name}}</p>
					<!--tabs标签-->
					<el-tabs type="border-card">
						<el-tab-pane  v-for = "(d,index)  in item.detail" >
							<span slot="label"><i class="el-icon-date"></i> {{d.tname}}</span>
							{{d.rateMoney}}元/度
						</el-tab-pane>
					</el-tabs>

					<div class="chargingOperate">
						<span @click="deleteChargeMode(item)">删除</span><span @click="editSPeakAndValleyBillingCharge(item)">编辑</span>
					</div>

				</div>

				<div class="addNewCharging" style="height: 171px;">
					<img @click="addSPeakAndValleyBillingCharge" :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/add_btn.png')" alt="" />
				</div>

			</div>


		</div>
		<AddNewChargingDialog ref="addNewCharging"></AddNewChargingDialog>
		<PeakAndValleyBillingViewDialog ref="peakAndValleyBillingViewDialog"></PeakAndValleyBillingViewDialog>
	</div>
</template>

<script>
	import AddNewChargingDialog from './dialogs/AddNewChargingDialog.vue'
	import PeakAndValleyBillingViewDialog from './dialogs/PeakAndValleyBillingViewDialog.vue'
	import meterManagerStore from './meterManagerStore.js'
	export default {
		components: {
			AddNewChargingDialog,
			PeakAndValleyBillingViewDialog
		},
		props: {},
		data() {
			return {
				nowTab: 0,
				tabList: [{name:'单价计费',value:0},{name:'阶梯计费',value:1},{name:'费率计费',value:2}],
				activeName: 'first',

				nowUnitInfo: {}
			}
		},
		created() {},
		mounted() {
			meterManagerStore.commit("setNowUser", this.nowUser)
			meterManagerStore.commit("setNowUnit", {
				unit:this.nowUnit,activeName:this.activeName
			})
		},
		destroyed() {},
		computed: {
			nowUser() {
				return this.$store.userStore.state.nowUserInfo
			},
			nowUnit() {
				return this.$store.unitStore.state.nowUnit
			},
			allChargeMode() {
				return meterManagerStore.state.allChargeMode
			},
		},
		watch: {
			nowUser(nv, ov) {
				meterManagerStore.commit("setNowUser", nv)
			}
		},
		methods: {
			handleClick(tab, event) {

				if (this.activeName=='second'){

					this.nowTab=3;
					this.tabList= [{name:'单价计费',value:3},{name:'阶梯计费',value:4}];

				}else {
					this.nowTab=0;
					this.tabList= [{name:'单价计费',value:0},{name:'阶梯计费',value:1},{name:'费率计费',value:2}];
				}

				meterManagerStore.commit("setNowUnit", {
					unit:this.nowUnit,activeName:this.activeName
				})
			},
			saveUnitInfo() {

			},
			addSingleCharge() {
				this.$refs.addNewCharging.open('新增单价计费', 'single',this.activeName, {}, result => {
					this.saveChargeMode(result)
				})
			},
			addStepCharge() {
				this.$refs.addNewCharging.open('新增阶梯计费', 'step',this.activeName, {}, result => {
					this.saveChargeMode(result)
				})
			},

			//lxk 2020-09-14新增尖峰平谷
			addSPeakAndValleyBillingCharge() {
				this.$refs.peakAndValleyBillingViewDialog.open('新增费率计费', '', {}, result => {
					this.saveChargeMode(result)
				})
			},

			//lxk 2020-09-14编辑尖峰平谷
			editSPeakAndValleyBillingCharge(item) {
				this.$refs.peakAndValleyBillingViewDialog.open('编辑费率计费', '', item, result => {
					this.saveChargeMode(result)
				})
			},

			// 保存计费方式
			saveChargeMode(data) {
				this.$api.meterReadingApi.saveMeterBillingMode(data.pkid, data.name,this.activeName, data.billingMode, data.deductionStandard, this.nowUnit.id, respon => {
					this.$dialogMethod.showMessage('保存成功')
					meterManagerStore.commit('getAllMeterBillingMode',{
						unitId:this.nowUnit.id,activeName:this.activeName
					} )
				}, err => {
					this.$dialogMethod.showMessage('保存失败')
				})
			},

			// 删除计费方式
			deleteChargeMode(item) {
				this.$api.meterReadingApi.deleteMeterBillingMode(item.pkid, respon => {
					this.$dialogMethod.showMessage(respon)
					meterManagerStore.commit('getAllMeterBillingMode',{
						unitId:this.nowUnit.id,activeName:this.activeName
					})
				}, err => {
					this.$dialogMethod.showMessage(err)
				})
			},
			// 编辑计费方式
			editChargeMode(item) {
				if(item.billingMode == 'SingleBilling'){
					this.$refs.addNewCharging.open('编辑单价计费', 'single',this.activeName, item, result => {
						this.saveChargeMode(result)
					})
				}else if(item.billingMode == 'StepBilling'){
					this.$refs.addNewCharging.open('编辑阶梯计费', 'step',this.activeName, item, result => {
						this.saveChargeMode(result)
					})
				}
			},
			// 查看费率计费详情
			viewDetails(item) {
				this.$refs.peakAndValleyBillingViewDialog.open(copy(item))
			}
		}
	}
</script>

<style scoped>
	.tabsContainer{
		width: calc(100% - 40px);
		padding: 20px;
		height: calc(100% - 40px);
		background: #FFFFFF;
	}

	.chargingDetailLi{
		width: calc((100% - 176px) / 8);
		border: solid 1px #E4E4E4;
		border-radius: 6px;
		margin: 30px 10px 0 10px;
		text-align: center;
	}

	.chargingTitle{
		line-height: 35px;
		background-color: #F2F2F2;
		border-bottom: solid 1px #E4E4E4;
	}

	.chargingPrice{
		line-height: 45px;
		color: #919191;
	}

	.chargingDetails{
		padding: 0 10px;
	}

	.chargingDetails>p{
		line-height: 32px;
		text-align: left;
		color: #919191;
		border-bottom: solid 1px #E4E4E4;
	}

	.chargingDetails>p:last-child{
		border-bottom: none;
	}

	.chargingDetails>p>span{
		color: #919191;
	}

	.chargingOperate{
		border-top: solid 1px #E4E4E4;
	}

	.chargingOperate>span{
		display: inline-block;
		line-height: 34px;
		cursor: pointer;
		width: calc(50% - 0.5px);
	}

	.chargingOperate>span:first-child{
		border-right: solid 1px #E4E4E4;
		color: #CCCCCC;
	}

	.chargingOperate>span:last-child{
		color: #409EFF;
	}

	.addNewCharging{
		display: flex;
		width: calc((100% - 176px) / 8);
		margin: 30px 10px 0 10px;
		align-items: center;
		justify-content: center;
	}

	.addNewCharging>img{
		cursor: pointer;
	}

	.tabHeader{
		border-bottom: solid 1px #E4E4E4;
	}

	.tabHeader>span{
		display: inline-block;
		margin-right: 30px;
		line-height: 30px;
		position: relative;
		top: 1px;
		cursor: pointer;
	}

	.tabAct{
		color: #409EFF;
		border-bottom: solid 1px #409EFF;
	}

	.tabBody{
		display: flex;
		align-items: flex-start;
		align-content: flex-start;
		flex-wrap: wrap;
	}

	@media screen and (max-width: 1600px) {
		.chargingDetailLi{
			width: calc((100% - 154px) / 7);
		}

		.addNewCharging{
			width: calc((100% - 154px) / 7);
		}
	}

	@media screen and (max-width: 1650px) {
		.chargingDetailLi{
			width: calc((100% - 132px) / 6);
		}

		.addNewCharging{
			width: calc((100% - 132px) / 6);
		}
	}
</style>
